import snippets from './snippets';

const entity = snippets('mailingLabelSnippets');

const reducer = entity.reducer;
export {reducer as default, entity};
